<template>
  <div class="user-guide-container">
    <iframe
      ref="userGuideFrame"
      src="/user-guide/index.html"
      class="user-guide-iframe"
      title="User Guide Documentation"
      @load="onIframeLoad"
      @error="onIframeError"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "UserGuide",
  methods: {
    onIframeLoad() {
      console.log("User guide loaded successfully");
    },
    onIframeError(error) {
      console.error("Error loading user guide:", error);
    },
  },
  mounted() {
    // Verify the iframe source is accessible
    console.log("UserGuide component mounted, loading:", this.$refs.userGuideFrame?.src);
  },
};
</script>

<style scoped>
.user-guide-container {
  width: 100%;
  min-height: 100vh;
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}

.user-guide-iframe {
  width: 100%;
  flex: 1;
  min-height: 600px;
  border: none;
  display: block;
}
</style>
